export default __webpack_public_path__ + "static/fuzzy-08a740029434cab4e9e9d212ddbc5a7c.png";